var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, watch } from "@chorda/core";
import { Field, Fields, RowLayout } from "chorda-bulma";
import { withList } from "../../utils";
import { Tmdb } from "../../api";
import { TextInput } from "../../helpers";
import { MovieListItem } from "./common/items";
import { withInfiniteScroll } from "./common/scroll";
const query = observable('');
const genres = observable([]);
const loadConfig = () => Tmdb.api.getConfiguration();
const loadGenres = (lang) => {
    return Tmdb.api.getMovieGenres(lang).then(response => {
        genres.$value = response.genres;
    });
};
const x = {
    injections: {
    //infiniteItems: () => []
    //items: $ => $.
    }
};
export default () => {
    return RowLayout([
        Fields({
            fields: [
                Field({
                    control: TextInput({
                        value$: () => query
                    })
                })
            ]
        }),
        withInfiniteScroll(withList({
            defaultItem: MovieListItem({
                movie$: (scope) => scope.item,
                genres$: () => genres,
            }),
            styles: {
                maxHeight: 380,
                overflowY: 'auto'
            },
            injections: {
                items: $ => $.infiniteItems
            },
            joints: {
                autoLoad: ({ infiniteScroll }) => __awaiter(void 0, void 0, void 0, function* () {
                    watch(() => {
                        infiniteScroll.resetAndGetFirst();
                    }, [query]);
                    yield Promise.all([loadConfig(), loadGenres('ru')]);
                    query.$value = 'руб';
                })
            },
            events: {
                onNextPage: (pageId, { infiniteScroll }) => {
                    if (query.$value != '') {
                        Tmdb.api.searchMovie({ page: pageId, query: query.$value, language: 'ru' }).then(response => {
                            infiniteScroll.update(pageId, response.results, response.total_pages);
                        });
                    }
                    else {
                        infiniteScroll.update(pageId, [], 0);
                    }
                }
            },
        })),
        // withIterableItems(<ListBlueprint<Tmdb.Movie, MoviesScope&InfiniteScrollScope<Tmdb.Movie>>>{
        //     defaultItem: MovieListItem({
        //         movie$: (scope) => scope.item,
        //         genres$: () => genres,
        //     }),
        //     as: withInfiniteScroll({
        //         styles: {
        //             maxHeight: 380,
        //             overflowY: 'auto'
        //         },
        //         joints: {
        //             autoLoad: async ({infiniteScroll}) => {
        //                 query.$subscribe(() => {
        //                     infiniteScroll.resetAndGetFirst()
        //                 })
        //                 await Promise.all([loadConfig(), loadGenres('ru')])
        //                 query.$value = 'руб'
        //             }
        //         },
        //         events: {
        //             onNextPage: (pageId, {infiniteScroll}) => {
        //                 if (query.$value != '') {
        //                     Tmdb.api.searchMovie({page: pageId, query: query.$value, language: 'ru'}).then(response => {
        //                         infiniteScroll.update(pageId, response.results, response.total_pages)
        //                     })
        //                 }
        //                 else {
        //                     infiniteScroll.update(pageId, [], 0)
        //                 }
        //             }
        //         }
        //     }),
        //     injections: {
        //         items: $ => $.infiniteItems
        //     }
        // }),
        // DynamicList<Tmdb.Movie[], MoviesScope&InfiniteScrollScope<Tmdb.Movie>>({
        //     defaultItem: MovieListItem({
        //         movie$: (scope) => scope.item,
        //         genres$: () => genres,
        //     }),
        //     items$: (scope) => scope.infiniteItems,
        //     as: withInfiniteScroll({
        //         styles: {
        //             maxHeight: 380,
        //             overflowY: 'auto'
        //         },
        //         joints: {
        //             autoLoad: async ({infiniteScroll}) => {
        //                 query.$subscribe(() => {
        //                     infiniteScroll.resetAndGetFirst()
        //                 })
        //                 await Promise.all([loadConfig(), loadGenres('ru')])
        //                 query.$value = 'руб'
        //             }
        //         },
        //         events: {
        //             onNextPage: (pageId, {infiniteScroll}) => {
        //                 if (query.$value != '') {
        //                     Tmdb.api.searchMovie({page: pageId, query: query.$value, language: 'ru'}).then(response => {
        //                         infiniteScroll.update(pageId, response.results, response.total_pages)
        //                     })
        //                 }
        //                 else {
        //                     infiniteScroll.update(pageId, [], 0)
        //                 }
        //             }
        //         }
        //     })
        // }),
    ]);
};
